module.exports = __webpack_public_path__ + "img/NA.01e8a658.svg";